import type {AxiosError} from 'axios';
import {useMutation, useQueryClient, type UseMutationOptions, type UseMutationResult} from 'react-query';
import {updateResidence, type UpdateResidenceRequest, type UpdateResidenceResponse} from '../../http';

export function useUpdateResidence(
	options?: UseMutationOptions<UpdateResidenceResponse, AxiosError, UpdateResidenceRequest>,
): UseMutationResult<UpdateResidenceResponse, AxiosError, UpdateResidenceRequest> {
	const queryClient = useQueryClient();

	return useMutation<UpdateResidenceResponse, AxiosError, UpdateResidenceRequest>(
		(request) => updateResidence(request).then(({data}) => data),
		{
			...options,
			onSuccess: (data, variables, context) => {
				queryClient.invalidateQueries({queryKey: ['identification', 'info']});
				options?.onSuccess?.(data, variables, context);
			},
		},
	);
}
